// MapObject3D.tsx — Buildings Set1 §6.1: the 3D-mode per-object component, the counterpart of
// `MapObjectUI` (the 2D-branch per-object visuals). Mounted from `MapSurface.tsx`'s
// `view3DActive` branch, and renders the object's 3D geometry. For a non-prototype `Mod_Building`
// it mounts a `Building3D`; other object kinds slot in as their 3D paths land (P3+). The 2D plan
// overlays live in `MapObjectUI` (`Building/PlanOverlays2D.tsx`).
import {observer_mgl} from "mobx-graphlink";
import React from "react";
import {MapObject} from "../../../../Server/DB/mapObjects/@MapObject.js";
import {Mod_Building} from "../../../../Server/DB/mapObjects/@MapObject/ObjModifiers/Mod_Building.js";
import {DMap} from "../../../../Server/DB/maps/@Map.js";
import {MapState} from "../../../../Store/main/maps/@MapState.js";
import {Building3D} from "./Building3D.js";

/** Cheap non-accessor predicate: true when `obj` carries an ENABLED, NON-prototype `Mod_Building`
 *  (i.e. one that actually generates geometry). Used to filter the common case (zero extra
 *  components) before mounting the per-object 3D/2D building renderers. */
export function ObjHasRenderableBuilding(obj: MapObject): boolean {
	return (obj.modifiers ?? []).some(m=>m.enabled && m.building && m.building.fallbackFor == null);
}

export const MapObject3D = observer_mgl((props: {obj: MapObject, map: DMap, mapState: MapState})=>{
	const {obj, map, mapState} = props;
	const buildingMod = (obj.modifiers ?? []).find(m=>m.enabled && m.building && m.building.fallbackFor == null)?.building as Mod_Building|n;
	if (buildingMod == null) return null;
	return <Building3D obj={obj} map={map} mapState={mapState} mod={buildingMod}/>;
});
